import * as _ from 'lodash'
import {LeaseRegistry} from "./LeaseRegistry";
import {PAWebSocketClient} from "../PA.Core/PAWebSocketClient";
import * as AGChannel from "ag-channel"

export const LeaseServerChannelId = "PALeaseServer"

export interface ILeaseServerMessage {
    requestName: string,
    classList?: string[],
    options?: any
}


export class LeaseServer {

    private _socket: PAWebSocketClient;
    private _channel: AGChannel<ILeaseServerMessage>;

    constructor() {
        const self = this

        let socket = new PAWebSocketClient();
        self._socket = socket;

        self.setupChannelEventHandlers();
    }

    private async setupChannelEventHandlers(): Promise<void> {
        const self = this
        let channel = await self._socket.getChannel(LeaseServerChannelId);
        channel.subscribe({});
        self._channel = channel;

        (async ()=> {
            for await (let msg of self._channel){
                try {
                    let requestName = msg?.requestName
                    switch (requestName){
                        case "resetFunction":
                            //-- console.log("LeaseServer: resetFunction msg received: ", msg)
                            let classList = msg?.classList || []
                            if (_.isArray(classList)){
                                LeaseRegistry.invalidateLeasesByClassList(classList);
                            }
                            break;
                        default:
                            console.log("Unknown Message on Lease Channel: ", msg)
                    }
                } catch (err){
                    console.log("LeaseServer: error handling message: ", msg, " error: ", err)
                }
            }
        })()

    }

    public broadcastResetLeaseClass(classList: string[] | string) {
        if(_.isString(classList)){
            classList = [classList]
        }

        if(!_.isUndefined(this._channel)){
            let msg: ILeaseServerMessage = {
                requestName: 'resetFunction',
                classList: classList,
                options: {}
            }
            this._channel.transmitPublish(msg)
        }
    }

}
